/** Readable names for report columns (echo abbreviations where clinicians use them). */
const NAMES: Record<string, string> = {
  ejection_fraction: 'Ejection fraction (EF)',
  left_ventricle_diastolic_diameter: 'LV internal diameter, diastole (LVIDd)',
  left_ventricle_systolic_diameter: 'LV internal diameter, systole (LVIDs)',
  left_ventricle_septal_wall_thickness: 'Interventricular septum (IVSd)',
  left_ventricle_posterior_wall_thickness: 'LV posterior wall (LVPWd)',
  left_atrium_dimensions: 'Left atrium (LA)',
  aortic_root_diameter: 'Aortic root',
  right_ventricle_diameter: 'RV diameter (RVIDd)',
  mitral_valve_ea_ratio: 'Mitral E/A ratio',
  pulmonary_artery_pressure: 'PA pressure (PASP)',
  left_ventricular_outflow_tract_diameter: 'LVOT diameter',
  aortic_valve_pressure_gradient_max: 'AV peak gradient',
  aortic_valve_mean_peak_gradient: 'AV mean gradient',
  left_ventricular_outflow_tract_pressure_gradient_max: 'LVOT peak gradient',
  left_ventricular_outflow_tract_velocity_time_integral: 'LVOT VTI',
  left_ventricular_outflow_tract_v1_velocity: 'LVOT V1 velocity',
  left_ventricular_outflow_tract_mean_velocity: 'LVOT mean velocity',
  e_point_septal_separation: 'E-point septal separation (EPSS)',
  mitral_valve_deceleration_time: 'Mitral deceleration time',
  mitral_valve_peak_e_wave_velocity: 'Mitral E velocity',
  mitral_valve_peak_a_wave_velocity: 'Mitral A velocity',
  mitral_valve_early_diastolic_lateral_velocity: "Mitral e' lateral",
  mitral_valve_early_diastolic_medial_velocity: "Mitral e' medial",
  tricuspid_regurgitation_maximum_velocity: 'TR peak velocity',
  tricuspid_regurgitation_pressure_gradient: 'TR pressure gradient',
  right_ventricular_outflow_tract_velocity_time_integral: 'RVOT VTI',
  age: 'Age',
  weight: 'Weight',
  height: 'Height',
  gender: 'Sex',
};

const ABBREV: [RegExp, string][] = [
  [/\bleft ventricular\b|\bleft ventricle\b/g, 'LV'],
  [/\bright ventricular\b|\bright ventricle\b/g, 'RV'],
  [/\bventricular outflow tract\b/g, 'VOT'],
  [/\bvelocity time integral\b/g, 'VTI'],
];

export function measurementName(key: string): string {
  if (NAMES[key]) return NAMES[key];
  let s = key.replace(/_/g, ' ');
  ABBREV.forEach(([re, to]) => (s = s.replace(re, to)));
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function sectionName(key: string): string {
  const s = key.replace(/_/g, ' ');
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function deriveExtension(url: string): string {
  try {
    const last = new URL(url).pathname.split('/').pop() || '';
    return last.includes('.') ? last.split('.').pop() || '' : '';
  } catch {
    const last = url.split('?')[0].split('/').pop() || '';
    return last.includes('.') ? last.split('.').pop() || '' : '';
  }
}
